import {
  sendGtmPostMessageTim,
  sendGa4PostMessageTim,
} from '../../services/timPostMessages';
import { useChannelStore } from '../../store/channel';
import { useSessionStore } from '../../store/session';
import { useCustomerStore } from '../../store/customer';
import eventService from '../../services/eventService';

let channel = null;

const addEventToDatalayer = (obj: Record<string, unknown>) => {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push(obj);

  if (!channel) channel = useChannelStore.getState().channel;
  sendGtmPostMessageTim({ message: 'gtm_tim_recarga', data: obj }, channel);
};

const addEventToGa4 = (obj: Record<string, unknown>) => {
  const currentChannel = useChannelStore.getState().channel;
  sendGa4PostMessageTim(obj, currentChannel);
};

const addEventToLoop = ({
  type,
  tags,
}: {
  type: string;
  tags: Record<string, string>;
}) => {
  const { msisdn, sessionLoopId } = useSessionStore.getState();
  const currentChannel = useChannelStore.getState().channel;
  const customerStatus = useCustomerStore.getState().customer?.status;
  const utmTerm = customerStatus
    ? customerStatus === 'CREATED'
      ? 'adesao'
      : 'recorrente'
    : undefined;
  const rawTags = {
    channel: 'web',
    portal: currentChannel,
    utm_source: 'frontend_tim_recarga',
    ...(utmTerm && { utm_term: utmTerm }),
    ...tags,
  };
  // `reduce` no lugar de `Object.fromEntries`: o bundle não carrega core-js
  // (confirmado no app.js de produção), então nenhum built-in é polyfillado, e
  // `Object.fromEntries` só existe a partir do Safari 12.1 — quebrava para quem
  // está abaixo disso, derrubando o envio de eventos ao Loop. `Object.entries`
  // e `reduce` são suportados em toda a base.
  const normalizedTags = Object.entries(rawTags).reduce<
    Record<string, unknown>
  >((acc, [k, v]) => {
    acc[k] = typeof v === 'string' ? v.toLowerCase() : v;
    return acc;
  }, {});
  eventService
    .send(msisdn, {
      type,
      msisdn,
      session_id: sessionLoopId,
      tags: normalizedTags,
    })
    .catch(() => {});
};

export { addEventToDatalayer, addEventToGa4, addEventToLoop };
